import type * as api from '@gitbook/api-client';
import type * as analytics from '@gitbook/app-analytics/client';
import type { MaybePromise } from '@gitbook/util-ts';

import { CreateTranslationDialog } from '../../Translations';

interface CreateContentSourceTranslationDialogProps {
    organizationId: string;
    analyticsContext: analytics.AnalyticsContextSpaceContent;
    onSubmit: (source: api.ComputedContentSourceRevisionTranslation) => MaybePromise<void>;
    currentSpace: api.Space;
}

/**
 * Dialog to create a new content source translation.
 * For now, we always create a new translation. In the future, we might want to reuse an existing
 * translation if it already exists.
 */
export function CreateContentSourceTranslationDialog(
    props: CreateContentSourceTranslationDialogProps
) {
    const { onSubmit, ...rest } = props;

    return (
        <CreateTranslationDialog
            {...rest}
            onSubmit={async ({ translation }) => {
                await onSubmit({
                    type: 'builtin:translation',
                    props: {},
                    dependencies: {
                        translation: {
                            ref: {
                                kind: 'translation',
                                translation: translation.id,
                            },
                        },
                    },
                });
            }}
            intent="computed_content"
        />
    );
}
